import OrderDTO from "@/dto/order/OrderDTO";
import { ModalStore } from "@/hooks/Modal/ModalStore";
import ReissueOrderModal from "../../dialogs/ReissueOrderModal";
import GlobalStore from "@/store";
import { ShipValidationRuleKey } from "@/services/ship/type";
import { validateShipping } from "@/services/ship";

interface ReissueShipParams {
    modalStore: ModalStore;
    globalStore: typeof GlobalStore;
    selectedOrders: OrderDTO[];
    onShipTaskDone(): void;
    defaultSelectAllEwaybills?: boolean;
}

/**
 * 补发包裹
 */
export async function execReissueOrder(params: ReissueShipParams) {
    const { modalStore, globalStore, selectedOrders, defaultSelectAllEwaybills, onShipTaskDone } = params;

    const { canShip, canShipOrders } = await validateShipping({
        globalStore,
        orders: selectedOrders,
        rule: {
            [ShipValidationRuleKey.checkRefundingOrder]: true,
        },
    });

    if (!canShip || canShipOrders.length === 0) {
        return;
    }

    modalStore.openModal(ReissueOrderModal, {
        orders: selectedOrders,
        onTaskDone: onShipTaskDone,
        defaultSelectAllEwaybills,
    });
}
